export default "/images/mail.svg?eee1baa73917a6ad8cc5ab655510875a";